// extracted by mini-css-extract-plugin
export default {"hideScrollbar":"c2b14dcf","container":"c5797725","noScroll":"e59b7512","dataRow":"a1b70cf8","cell":"b04d24d2"};